import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/20/solid";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export const HelpPage = () => {
  const faqs = [
    {
      question: "Jak działa Skaner giełdowy?",
      answer: `Skaner giełdowy automatycznie przeszukuje kilkadziesiąt
          źródeł informacji, zarówno popularnych portali gospodarczych oraz
          giełdowych, jak i serwisów specjalistycznych. Po skonfigurowaniu listy
          interesujących spółek, narzędzie filtruje wiadomości i dostarcza
          użytkownikowi wyłącznie te, które dotyczą wybranych firm. Dzięki temu
          użytkownik na bieżąco otrzymuje tylko istotne dla niego informacje –
          bez potrzeby samodzielnego przeglądania i analizowania wielu portali,
          oszczędzając w ten sposób cenny czas i energię.`,
    },
    {
      question: "Jak skonfigurować Skaner giełdowy?",
      answer: (
        <>
          <p>
            Aby skonfigurować skaner giełdowy, wystarczy kliknąć w ikonę koła
            zębatego w prawym górnym rogu ekranu na{" "}
            <Link
              to="/"
              className="font-semibold"
              onClick={() => localStorage.setItem("initialVisit", "true")}
            >
              stronie głównej
            </Link>
            . Następnie w panelu bocznym można dodać interesujące spółki do
            listy obserwowanych. Po dodaniu spółek, skaner automatycznie zacznie
            przeszukiwać wiadomości i dostarczać użytkownikowi tylko te, które
            dotyczą wybranych firm.
          </p>
          <p>
            <iframe
              className="mx-auto mt-6"
              width="600"
              height="304"
              src="https://www.youtube.com/embed/mF4un7D4P8o?si=7WpcInp-cB30HnPe"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </p>
        </>
      ),
    },
    {
      question: "Czy masz dodatkowe pytania?",
      answer: (
        <>
          Wszelkie pytania i zgłoszenia prosimy kierować na adres mailowy{" "}
          <a className="font-semibold" href="mailto:kontakt@skaner.ai">
            kontakt@skaner.ai
          </a>
          .
        </>
      ),
    },
    // More questions...
  ];
  return (
    <>
      <Helmet>
        <title>Najczęściej zadawane pytania – Skaner giełdowy</title>
        <meta
          name="description"
          content={`Strona pomocy Skanera wiadomości giełdowych`}
        />
      </Helmet>
      <div className="w-full border-b border-gray-100 py-4">
        <div className="mx-auto flex max-w-5xl items-center px-4 sm:px-6 lg:px-8">
          <div>
            <h1 className="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
              Najczęściej zadawane pytania
            </h1>
          </div>
        </div>
      </div>
      <dl className="divide-y divide-gray-100">
        {faqs.map((faq) => (
          <>
            <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
              <Disclosure
                key={faq.question}
                as="div"
                className="py-6 first:pt-0 last:pb-0"
              >
                <div className="mx-auto w-full max-w-5xl px-4 sm:px-6 lg:px-8">
                  <dt>
                    <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                      <span className="text-base/7 font-semibold">
                        {faq.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        <PlusSmallIcon
                          aria-hidden="true"
                          className="size-6 group-data-[open]:hidden"
                        />
                        <MinusSmallIcon
                          aria-hidden="true"
                          className="size-6 group-[&:not([data-open])]:hidden"
                        />
                      </span>
                    </DisclosureButton>
                  </dt>
                  <DisclosurePanel as="dd" className="mt-2 pr-12">
                    <p className="text-base/7 text-gray-600">{faq.answer}</p>
                  </DisclosurePanel>
                </div>
              </Disclosure>
            </div>
          </>
        ))}
      </dl>
    </>
  );
};
